import { millwrightsRiskOptions } from '@/constants';
import { MillwrightsFiltersI } from '@/types';
import { useState } from 'react';

const initialFilters = {
  riskFactor: millwrightsRiskOptions[0],
};

export const useMillwrightsFilters = () => {
  const [millwrightsFilters, setMillwrightsFilters] =
    useState<MillwrightsFiltersI>(initialFilters);

  const updateFilters = (filters: Partial<MillwrightsFiltersI>) => {
    setMillwrightsFilters((prevState) => ({ ...prevState, ...filters }));
  };

  const resetFilters = () => {
    setMillwrightsFilters(initialFilters);
  };

  return {
    millwrightsFilters,
    resetFilters,
    updateFilters,
  };
};
